// Sandbox routing-pass identity context (WP1).
//
// `SandboxEntryGuard` (App.jsx) verifies the fragment routing pass on gated
// hosts and, when the pass is valid for a signed-out visitor, provides the
// verified identity here so the login page can render "Signing in as …" and
// submit the password login with that email.
//
// This lives in its own module (not App.jsx) so PersonaLoginPage can consume
// the hook without creating an App.jsx <-> PersonaLoginPage import cycle.

import { createContext, useContext } from 'react';

export const SandboxPassContext = createContext(null);

/**
 * The pass-verified identity for this gated host, or null when no verified
 * pass identity applies (guard inactive, user already authenticated, …).
 *
 * @returns {{ email: string, displayName?: string }|null}
 */
export function useSandboxPassIdentity() {
  const ctx = useContext(SandboxPassContext);
  return ctx?.identity || null;
}
